import React from 'react';
import { Mail } from 'lucide-react';
export const ContactSection = () => {
  return <section id="contact" className="py-16 md:py-24 bg-aspira-white" data-id="element-41">
      <div className="container mx-auto px-4 md:px-6" data-id="element-42">
        <div className="max-w-3xl mx-auto bg-gradient-to-br from-aspira-navy to-aspira-blue rounded-2xl shadow-lg overflow-hidden" data-id="element-43">
          <div className="p-8 md:p-12 text-white" data-id="element-44">
            <h2 className="text-3xl font-bold mb-6" data-id="element-45">Get in Touch</h2>
            <p className="mb-8 text-aspira-white opacity-90" data-id="element-46">
              Ready to start your growth journey? Contact us today to learn how
              Aspira Works can help your business thrive.
            </p>
            <div className="flex items-center" data-id="element-47">
              <Mail className="mr-4 text-aspira-green" size={24} data-id="element-48" />
              <div data-id="element-49">
                <p className="font-medium text-lg" data-id="element-50">Email Us</p>
                <a href="mailto:hello@aspiraworks.com" className="text-aspira-white hover:text-aspira-green transition-colors" data-id="element-51">
                  hello@aspiraworks.com
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};